import type { StyleRule } from '@archipro-design/aria';

export const VideoContainer: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.primitive.black,
    width: '100%',
    height: '100%',
});

export const VideoPlayer: StyleRule = () => ({
    width: '100%',
    height: '100%',
});
